// AUTO-GENERATED by scripts/sync-news-media.js — do not edit by hand.
// Regenerate with: npm run sync:news  (also runs on start/build automatically)
//
// Maps each news SLUG to every image in public/images/news/<SLUG>/, in
// numeric-aware filename order. The first entry is used as the card/banner
// image. Add or remove files in the folder and this rebuilds itself.

const NEWS_MEDIA = {
  "academic-council-3rd": [
    "/images/news/academic-council-3rd/01.jpeg",
    "/images/news/academic-council-3rd/02.jpeg",
    "/images/news/academic-council-3rd/03.jpeg",
    "/images/news/academic-council-3rd/04.jpeg",
    "/images/news/academic-council-3rd/05.jpeg",
    "/images/news/academic-council-3rd/06.jpeg",
    "/images/news/academic-council-3rd/07.jpeg",
    "/images/news/academic-council-3rd/08.jpeg",
    "/images/news/academic-council-3rd/09.jpeg",
    "/images/news/academic-council-3rd/10.jpeg",
    "/images/news/academic-council-3rd/11.jpeg",
    "/images/news/academic-council-3rd/12.jpeg",
    "/images/news/academic-council-3rd/13.jpeg",
    "/images/news/academic-council-3rd/14.jpeg",
    "/images/news/academic-council-3rd/15.jpeg",
    "/images/news/academic-council-3rd/16.jpeg",
    "/images/news/academic-council-3rd/17.jpeg",
    "/images/news/academic-council-3rd/18.jpeg",
    "/images/news/academic-council-3rd/19.jpeg",
    "/images/news/academic-council-3rd/20.jpeg",
    "/images/news/academic-council-3rd/21.jpeg",
    "/images/news/academic-council-3rd/22.jpeg",
    "/images/news/academic-council-3rd/23.jpeg",
    "/images/news/academic-council-3rd/24.jpeg",
    "/images/news/academic-council-3rd/25.jpeg",
    "/images/news/academic-council-3rd/26.jpeg",
    "/images/news/academic-council-3rd/27.jpeg",
    "/images/news/academic-council-3rd/28.jpeg",
    "/images/news/academic-council-3rd/29.jpeg",
    "/images/news/academic-council-3rd/30.jpeg",
    "/images/news/academic-council-3rd/31.jpeg",
    "/images/news/academic-council-3rd/32.jpeg",
    "/images/news/academic-council-3rd/33.jpeg",
    "/images/news/academic-council-3rd/34.jpeg",
    "/images/news/academic-council-3rd/35.jpeg",
    "/images/news/academic-council-3rd/36.jpeg",
    "/images/news/academic-council-3rd/37.jpeg",
    "/images/news/academic-council-3rd/38.jpeg",
    "/images/news/academic-council-3rd/39.jpeg",
    "/images/news/academic-council-3rd/40.jpeg",
    "/images/news/academic-council-3rd/41.jpeg"
  ],
  "chairman-hec-visit": [
    "/images/news/chairman-hec-visit/01.jpeg"
  ],
  "farewell-colonel-hassan-ali": [
    "/images/news/farewell-colonel-hassan-ali/01.jpeg",
    "/images/news/farewell-colonel-hassan-ali/02.jpeg",
    "/images/news/farewell-colonel-hassan-ali/03.jpeg",
    "/images/news/farewell-colonel-hassan-ali/04.jpeg"
  ],
  "independence-day-2026": [
    "/images/news/independence-day-2026/01.jpeg",
    "/images/news/independence-day-2026/02.jpeg",
    "/images/news/independence-day-2026/03.jpeg",
    "/images/news/independence-day-2026/04.jpeg",
    "/images/news/independence-day-2026/05.jpeg",
    "/images/news/independence-day-2026/06.jpeg",
    "/images/news/independence-day-2026/07.jpeg"
  ],
  "marka-e-haq-anniversary": [
    "/images/news/marka-e-haq-anniversary/01.jpeg"
  ],
  "syndicate-meeting-3rd": [
    "/images/news/syndicate-meeting-3rd/01.jpeg",
    "/images/news/syndicate-meeting-3rd/02.jpeg",
    "/images/news/syndicate-meeting-3rd/03.jpeg",
    "/images/news/syndicate-meeting-3rd/04.jpeg",
    "/images/news/syndicate-meeting-3rd/05.jpeg",
    "/images/news/syndicate-meeting-3rd/06.jpeg",
    "/images/news/syndicate-meeting-3rd/07.jpeg",
    "/images/news/syndicate-meeting-3rd/08.jpeg",
    "/images/news/syndicate-meeting-3rd/09.jpeg",
    "/images/news/syndicate-meeting-3rd/10.jpeg",
    "/images/news/syndicate-meeting-3rd/11.jpeg",
    "/images/news/syndicate-meeting-3rd/12.jpeg",
    "/images/news/syndicate-meeting-3rd/13.jpeg",
    "/images/news/syndicate-meeting-3rd/14.jpeg",
    "/images/news/syndicate-meeting-3rd/15.jpeg",
    "/images/news/syndicate-meeting-3rd/16.jpeg",
    "/images/news/syndicate-meeting-3rd/17.jpeg",
    "/images/news/syndicate-meeting-3rd/18.jpeg"
  ]
};

export default NEWS_MEDIA;
